import { Component, inject, OnInit } from '@angular/core';
import { MarketplaceFacade } from '@fgb/core';

@Component({
  selector: 'fgb-marketplace-page-v2',
  templateUrl: './marketplace-page-v2.component.html',
  styleUrl: './marketplace-page-v2.component.scss',
})
export class MarketplacePageV2Component implements OnInit {
  private marketplaceFacade = inject(MarketplaceFacade);

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItems();
  }
}
